import React, { Component } from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import { Colors, Icon as OriginalIcon } from 'advenio-components'
import ProfilePicture from '../ChildrenList/ProfilePicture'
import {
  ChildrenContainer,
  ChildrenDiv,
  StatusDiv,
  ProfileDiv,
  InfoDiv,
  NameDiv,
  IconsDiv,
  ActionButton,
  InfoDivOverlay,
  ProfileDivOverlay,
  CenterBadge,
} from '../ChildrenList/ChildrenList.styles'


const Icon = ({ height, type, width }) => (
  <OriginalIcon
    type={type}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    color={type === 'logIn' ? Colors.gray700 : Colors.gray500}
  />
)

Icon.propTypes = {
  height: PropTypes.number,
  type: PropTypes.string.isRequired,
  width: PropTypes.number,
}

Icon.defaultProps = {
  height: 24,
  width: 24,
}

class VirtualChildrenList extends Component {

  getInactiveChildren() {
    const newChildren = R.clone(
      this.props.children.filter(
        student => student.checkin && student.checkin.status === 'Inactive',
      ),
    )
    const children = newChildren.map((child, index, array) =>
      //eslint-disable-line
      (
        <ChildrenDiv key={child.id} type={child.checkin.status}>
          <StatusDiv type={child.checkin.status} />
          <ProfileDiv>
            <ProfileDivOverlay id={child.id} />
            <ProfilePicture
              profile_image={
                child.profile_pictures && child.profile_pictures['original']
              }
              type={child.checkin.status}
            />
          </ProfileDiv>
          <InfoDiv>
            <InfoDivOverlay id={child.id} />
            <NameDiv>
              <span>{`${child.first_name} ${child.last_name_paternal} ${child.last_name_maternal}`}</span>
            </NameDiv>
            <CenterBadge>{child.center.abbreviation}</CenterBadge>
          </InfoDiv>
          { child.status_id !== 5 &&(
            <IconsDiv>
              <ActionButton onClick={() => { this.assessment(child) }}>
                <Icon type="logIn" />
              </ActionButton>
            </IconsDiv>)}
        </ChildrenDiv>
      ),
    )
    return children
  }

  getActiveChildren() {
    const newChildren = R.clone(
      this.props.children.filter(
        student => student.checkin && student.checkin.status === 'Advenio',
      ),
    )
    const children = newChildren.map((currentValue, index, array) =>
      //eslint-disable-line
      (
        <ChildrenDiv key={index} type={currentValue.checkin.status}>
          <StatusDiv type={currentValue.checkin.status} />
          <ProfileDiv>
            <ProfileDivOverlay id={currentValue.id} />
            <ProfilePicture
              profile_image={
                currentValue.profile_pictures && currentValue.profile_pictures['original']
              }
              type={currentValue.checkin.status}
            />
          </ProfileDiv>
          <InfoDiv>
            <InfoDivOverlay id={currentValue.id} />
            <NameDiv>
              <span>{`${currentValue.first_name} ${currentValue.last_name_paternal} ${currentValue.last_name_maternal}`}</span>
            </NameDiv>
            <CenterBadge>{currentValue.center.abbreviation}</CenterBadge>
          </InfoDiv>
        </ChildrenDiv>
      ),
    )
    return children
  }

  getChildrenInNursesRoom() {
    const newChildren = R.clone(
      this.props.children.filter(
        student => student.checkin.status !== 'Advenio' && student.checkin.status !== 'Inactive',
      ),
    )
    const children = newChildren.map((currentValue, index, array) =>
      //eslint-disable-line
      (
        <ChildrenDiv key={index} type={currentValue.checkin.status}>
          <StatusDiv type={currentValue.checkin.status} />
          <ProfileDiv>
            <ProfileDivOverlay id={currentValue.id} />
            <ProfilePicture
              profile_image={
                currentValue.profile_pictures && currentValue.profile_pictures['thumb-sm']
              }
              type={currentValue.checkin.status}
            />
          </ProfileDiv>
          <InfoDiv>
            <InfoDivOverlay id={currentValue.id} />
            <NameDiv>
              <span>{`${currentValue.first_name} ${currentValue.last_name_paternal} ${currentValue.last_name_maternal}`}</span>
            </NameDiv>
            <CenterBadge>{currentValue.center.abbreviation}</CenterBadge>
          </InfoDiv>
        </ChildrenDiv>
      ),
    )
    return children
  }

  assessment = child => this.props.openAssessment(child)

  render() {
    return (
      <ChildrenContainer virtual>
        {this.getInactiveChildren()}
        {this.getChildrenInNursesRoom()}
        {this.getActiveChildren()}
      </ChildrenContainer>
    )
  }
}

export default VirtualChildrenList



// WEBPACK FOOTER //
// ./src/Components/VirtualChildrenList/index.jsx